// Define item-slider as a custom element
if (!customElements.get("item-slider")) {
  class ItemSlider extends HTMLElement {
    constructor() {
      super();
      this.start_x = 0;
      this.current_x = 0;
      this.dragging = false;
      this.delta_x = 0;
    }

    setup_items() {
      this.track = this.querySelector(".track");
      this.items = Array.from(this.track.querySelectorAll(".item"));

      this.scroll_amount = this.items[0].offsetWidth;

      this.button_prev = this.querySelector(".nav_prev");
      this.button_next = this.querySelector(".nav_next");

      this.button_prev.addEventListener("click", this.previous.bind(this));
      this.button_next.addEventListener("click", this.next.bind(this));
      this.check_buttons();
      window.addEventListener("resize", this.check_buttons.bind(this));

      for (let item of this.items) {
        item.all_skeletons = item.querySelectorAll(".skeleton");
        item.primary_image = item.querySelector(".image-primary");

        // Add event listener to remove skeletons when image is loaded
        if (item.primary_image) {
          item.primary_image.addEventListener(
            "load",
            this.item_loaded.bind(this, item)
          );
          // If image is already loaded, remove skeletons. Happens when image is cached
          if (item.primary_image.complete) {
            this.item_loaded(item);
          }
        }
      }
    }

    item_loaded(item) {
      for (let skeleton of item.all_skeletons) {
        skeleton.classList.remove("skeleton");
        skeleton.classList.remove("skeleton-text");
      }
    }



    check_buttons() {
      // If track is overflown, show buttons
      if (this.track.scrollWidth > this.track.offsetWidth) {
        this.button_prev.style.display = "flex";
        this.button_next.style.display = "flex";
      } else {
        this.button_prev.style.display = "none";
        this.button_next.style.display = "none";
        // this.track.style.gridAutoColumns = `clamp(280px, ${(1 / this.items.length) * 100}%, 350px)`;

        // If track has class track-collection-icons
        if (this.track.classList.contains("track-collection-icons")) {
          this.track.style.justifyContent = "center";
        }
      }
    }

    // Return idx of closest item to center of track
    get_center_item() {
      let track_center = this.track.offsetWidth / 2;
      let track_position = this.track.scrollLeft + track_center;
      let dist = Infinity;
      let closest_item = 0;
      let closest_item_idx = 0;
      this.items.forEach((item, idx) => {
        let item_center = item.offsetLeft + item.offsetWidth / 2;
        let item_dist = Math.abs(track_position - item_center);
        if (item_dist < dist) {
          dist = item_dist;
          closest_item = item;
          closest_item_idx = idx;
        }
      });
      return [closest_item, closest_item_idx];
    }

    previous() {
      let [center_item, center_item_idx] = this.get_center_item();
      // If first item, return
      if (center_item_idx === 0) return;
      let target = this.items[center_item_idx - 1];
      this.scroll_to_item(target);
    }

    next() {
      let [center_item, center_item_idx] = this.get_center_item();
      // If last item, return
      if (center_item_idx === this.items.length - 1) return;
      let target = this.items[center_item_idx + 1];
      this.scroll_to_item(target);
    }

    scroll_to_item(item) {
      this.track.scroll({
        left:
          item.offsetLeft - this.track.offsetWidth / 2 + item.offsetWidth / 2,
        behavior: "smooth",
      });
      // item.scrollIntoView({
      //   behavior: "smooth",
      //   block: "nearest",
      //   inline: "center",
      // });
    }
    connectedCallback() {
      this.setup_items();
    }
  }
  customElements.define("item-slider", ItemSlider);
}
